import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  Text,
} from "@chakra-ui/react";

interface DeleteDashboardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  dashboardName: string;
  isLoading?: boolean;
  t: (key: string, options?: Record<string, string>) => string;
}

export const DeleteDashboardModal: React.FC<DeleteDashboardModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  dashboardName,
  isLoading = false,
  t,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.300" />
      <ModalContent
        bg="white"
        borderRadius="8px"
        px="32px"
        py="40px"
        position="relative"
      >
        {/* Close Button - Styled like Figma */}
        <ModalCloseButton
          position="absolute"
          right="16px"
          top="16px"
          bg="blackAlpha.500"
          color="white"
          borderRadius="full"
          w="29px"
          h="29px"
          minW="29px"
          _hover={{ bg: "blackAlpha.600" }}
        />

        {/* Title */}
        <ModalHeader p={0} mb="24px">
          <Text
            fontSize="24px"
            fontWeight="600"
            color="#313f4d"
            lineHeight="24px"
          >
            {t("deleteDashboardTitle")}
          </Text>
        </ModalHeader>

        {/* Body */}
        <ModalBody p={0} mb="24px">
          <Text fontSize="16px" color="#3e4f61" lineHeight="normal">
            {t("deleteDashboardDescription", { dashboardName })}
          </Text>
        </ModalBody>

        {/* Action Buttons */}
        <Flex gap="24px" w="100%">
          {/* Cancel Button */}
          <Button
            flex={1}
            h="40px"
            bg="white"
            color="#086aa9"
            border="1px solid"
            borderColor="#086aa9"
            borderRadius="8px"
            fontWeight="400"
            fontSize="16px"
            boxShadow="0px 2px 0px 0px rgba(0,0,0,0.02)"
            _hover={{ bg: "blue.50" }}
            onClick={onClose}
            isDisabled={isLoading}
          >
            {t("goBack")}
          </Button>

          {/* Confirm Delete Button */}
          <Button
            flex={1}
            h="40px"
            bg="#086aa9"
            color="white"
            border="1px solid"
            borderColor="#086aa9"
            borderRadius="8px"
            fontWeight="400"
            fontSize="16px"
            boxShadow="0px 2px 0px 0px rgba(0,0,0,0.04)"
            _hover={{ bg: "#075a91" }}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {t("deleteAnyway")}
          </Button>
        </Flex>
      </ModalContent>
    </Modal>
  );
};

export default DeleteDashboardModal;
